import * as React from 'react';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';

import { ServicePickerWidget } from '../../../ServicePickerWidget';
import { PayPackageMicrofrontend } from '../../../PayPackageMicrofrontend';
import { PaymentWidgetMicrofrontend } from '../../../PaymentWidgetMicrofrontend';

import { IAppContext, TReduxStore } from '../../types';
import { AppContext } from '../AppContext';

export interface IAppModulesWrapperProps {
  context: IAppContext;
  reduxStore: TReduxStore;
}

/**
 * Не удалять!
 * В этот объект помещаются колбэки, которые вызывают мобильные приложения.
 * Таким образом обеспечивается передача данных mobile app → web app.
 */
if (process.env.IS_BROWSER_BUILD) {
  window.appInterfaceV2 = window.appInterfaceV2 || {};
}

export const AppModulesWrapper: React.FC<IAppModulesWrapperProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { userAgent },
    microfrontendsRegistry,
    isMicrofrontend,
  } = context;

  const deviceType = uaToDeviceType(userAgent || undefined);

  return (
    <StrictMode>
      <ErrorLogComponent logger={logger}>
        <AppContext.Provider value={context}>
          <UiKitContextProvider deviceType={deviceType}>
            <Provider store={reduxStore}>
              <MicrofrontendProvider registry={microfrontendsRegistry}>
                <ServicePickerWidget />

                <PayPackageMicrofrontend />

                {isMicrofrontend && <PaymentWidgetMicrofrontend />}
              </MicrofrontendProvider>
            </Provider>
          </UiKitContextProvider>
        </AppContext.Provider>
      </ErrorLogComponent>
    </StrictMode>
  );
};
